module.exports = __webpack_public_path__ + "img/9.ccbf816b.jpg";